import { useState } from "react";
import { LockKey, CheckCircle } from "@phosphor-icons/react";
import { toast } from "../components/ui/sonner";
import { createCheckoutSession, formatApiErrorDetail } from "../lib/api";

const FEATURES = [
  "Largest Leans — the model's strongest qualifying opinions",
  "Line Movement market intelligence across 10 leagues",
  "Full game, First 5 and NRFI/YRFI predictions",
  "SportsDesk multi-sportsbook download access",
  "15 Minute Kalshi Bot",
];

const Subscribe = () => {
  const [submitting, setSubmitting] = useState(false);

  const handleSubscribe = async () => {
    setSubmitting(true);
    try {
      const { checkout_url } = await createCheckoutSession();
      window.location.href = checkout_url;
    } catch (err) {
      toast.error(formatApiErrorDetail(err?.response?.data?.detail));
      setSubmitting(false);
    }
  };

  return (
    <div data-testid="subscribe-page" className="mx-auto flex min-h-[80vh] max-w-lg flex-col justify-center px-4 py-16">
      <div className="mb-6 text-center">
        <LockKey size={32} weight="bold" className="mx-auto mb-3 text-eb-accent" />
        <h1 className="font-heading text-3xl uppercase tracking-tight text-white sm:text-4xl">Subscribe to Continue</h1>
        <p className="mt-2 text-sm text-zinc-500">EdgeBall is a subscriber-only product. An active plan is required to access any page.</p>
      </div>

      <div className="rounded-lg border border-eb-accent/40 bg-eb-surface p-6">
        <div className="mb-4 flex items-baseline justify-between">
          <h2 className="font-heading text-lg uppercase tracking-tight text-white">EdgeBall Pro</h2>
          <div>
            <span className="font-heading text-3xl text-white">$19.99</span>
            <span className="text-sm text-zinc-500"> / month</span>
          </div>
        </div>
        <ul className="mb-6 space-y-2">
          {FEATURES.map((f) => (
            <li key={f} className="flex items-start gap-2 text-sm text-zinc-300">
              <CheckCircle size={16} weight="bold" className="mt-0.5 shrink-0 text-green-400" />
              {f}
            </li>
          ))}
        </ul>
        <button
          data-testid="subscribe-checkout-button"
          onClick={handleSubscribe}
          disabled={submitting}
          className="flex w-full items-center justify-center gap-2 rounded-md bg-eb-accent px-4 py-3 font-heading text-sm uppercase tracking-wide text-white transition-colors hover:bg-blue-600 disabled:opacity-50"
        >
          {submitting ? "Redirecting to checkout\u2026" : "Subscribe — $19.99/mo"}
        </button>
        <p className="mt-3 text-center text-xs text-zinc-600">Cancel anytime. Access is removed automatically if a payment is missed.</p>
      </div>
    </div>
  );
};

export default Subscribe;
